import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {ConsultationCategorySummaryModel} from '../consultationCategorySummary.model';
import {Injectable} from '@angular/core';
import {PermissionsConverter} from '../../../../../../common/converter/permissions.converter';
import {
    AgendaCategoryConverter
} from '../../../../../../agenda/modules/category/api/converter/agendaCategory.converter';

@Injectable({ providedIn: 'root' })
export class ConsultationCategorySummaryConverter extends HttpModelConverter<ConsultationCategorySummaryModel> {
    constructor(private agendaCategoryConverter: AgendaCategoryConverter) {
        super();
    }
    protected createInstance(): ConsultationCategorySummaryModel {
        return new ConsultationCategorySummaryModel();
    }

    protected enrichObject(result: ConsultationCategorySummaryModel, src: ConsultationCategorySummaryModel) {
        result.permissions = new PermissionsConverter().convert(src.permissions);
        result.agendaCategory = this.agendaCategoryConverter.convert(src.agendaCategory);
    }
}
